var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.priority && _vm.priority !== 'normal')?_c('b-icon',{staticClass:"priority-dot",attrs:{"icon":"circle-small"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }